// test1296
(1296 && 0);
